// src/auth/AuthGuard.js
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../contexts/JWTAuthContext';

const AuthGuard = ({ children }) => {
  const { isAuthenticated, isInitialized } = useContext(AuthContext);

  if (!isInitialized) {
    return <div>Loading...</div>; // Or you can use a spinner component
  }

  if (!isAuthenticated) {
    return <Navigate to="/session/signin" />;
  }

  return children;
};

export default AuthGuard;
